import * as types from '../types';
import moment from 'moment';
import update from 'immutability-helper';
import LegalDisclaimer from '../../LegalDisclaimer';

export const initialAddForm = {
    // employeeId: undefined,
    // dateApplied: moment().format('MM/DD/YYYY'),
    applicantID: '',
    applicantType: 2,
    applicantStatus: 1,
    remarks: '',
    firstName: '',
    middleName: '',
    lastName: '',
    suffixName: '',
    birthDate: null,
    age: '',
    cityAddress: '',
    zipCode: '',
    contactNumber: '',
    provincialAddress: '',
    provincialContactNumber: '',
    gender: -1,
    civilStatus: -1,
    religion: '',
    emailAddress: '',
    spouseName: '',
    spouseOccupation: '',
    spouseContactNumber: '',
    jobSource: 0,
    others: '',
    availableJob: 0,
    curriculumVitae: [],
    skills: [],
    educationalBackground: [],
    workExperience: [],
    characterReference: [],
    saved: false,
}

const defaultState = {
    loading: false,
    addForm: { ...initialAddForm },
    age: '',
    alert: {
        show: false,
        title: 'Create success',
        content: 'Successfuly created record.',
        confirmLabel: 'Ok',
        goBackToListFlag: false,
    },
    disclaimer: {
        shows: false,
        titles: 'DATA PRIVACY NOTICE',
        contents: LegalDisclaimer(),
    },
    fileUpload: {
        centered: true,
        fileShow: false,
        fileTitle: 'File Upload',
        size: 'lg',
        acceptedFile: ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'],
        subTitle: 'File must be of PDF, PNG, JPG formats',
    }
};

export default function addReducer(state = defaultState, action) {
    switch (action.type) {
        case types.CHG_FIELD:
        case types.CHG_STATUS:
            return update(state, {
                addForm: {
                    [action.payload.name]: { $set: action.payload.data }
                }
            });
        case types.RESET_ADD_DATA:
            return update(state, {
                addForm: { $set: initialAddForm },
                alert: { $set: action.payload }
            });
        case types.INSERT_LOADING:
            return update(state, {
                loading: { $set: action.payload }
            });
        case types.UPD_ADD_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.SHW_LEGAL_MODAL:
            return update(state, {
                disclaimer: { $set: action.payload }
            });
        case types.SHW_FILE_MODAL:
            return update(state, {
                fileUpload: { $set: action.payload }
            });
        case types.HIDE_MODAL:
            return update(state, {
                disclaimer: { shows: { $set: false } },
                fileUpload: { fileShow: { $set: false } }
            })
        case types.HIDE_ADD_ALERT:
            return update(state, {
                alert: { show: { $set: false } }
            })
        case types.CHG_APPLICANT_ID:
            return update(state, {
                addForm: {
                    applicantID: { $set: action.payload.data }
                }
            })
        case types.CHG_FILE_UPLD:
            return update(state, {
                addForm: {
                    curriculumVitae: { $set: action.payload.data }
                }
            })
        case types.CHG_FILE_UPLD:
            return update(state, {
                addForm: {
                    age: { $set: action.payload.data }
                }
            })
        default:
            return state;
    }
}